import {Component, HostBinding, Input, OnInit, Output} from '@angular/core';
import {DialogComponent} from '@tytapp/common';
import {Subject} from 'rxjs';

@Component({
    selector: 'tyt-modal-social-buttons',
    templateUrl: './modal-social-buttons.component.html',
    styleUrls: ['./modal-social-buttons.component.scss']
})
export class ModalSocialButtonsComponent {

    @Input() url!: string;

    @Output() onClose = new Subject();

    @HostBinding('style.top') @Input() top!: string;
    @HostBinding('style.left') @Input() left!: string;

}
